import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { ConsumerService } from "../../../services/api/consumer.service";
import { ConsumerActions } from "../../actions/consumer.actions";
import { FailState } from "../../models/fail-state";
import { AppState } from "../../reducers";
import { ConsumerSelectors } from "../../selectors/consumer.selectors";

@Injectable()
export class OrderCostStatsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.orderCostStats.get),
			withLatestFrom(this.store.select(ConsumerSelectors.orderCostStats)),
			switchMap(([action, state]) =>
				!_.has(state, "error") && !state.loading
					? of(ConsumerActions.orderCostStats.getSuccess(state))
					: of(ConsumerActions.orderCostStats.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.orderCostStats.getApi),
			switchMap(() =>
				this.consumerService.orderCostStats().pipe(
					map((stats) =>
						ConsumerActions.orderCostStats.getSuccess({ stats, loading: false })
					),
					catchError((error) =>
						of(ConsumerActions.orderCostStats.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerService: ConsumerService,
		private store: Store<AppState>
	) {}
}
